/*
* Palo Alto Theme - Custom JS
*/

(function() {

  // Fix 2: Guard hide-header near top of page to prevent flicker
  var HEADER_GUARD_PX = 130;
  var hideHeaderObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'class') {
        if (document.body.classList.contains('hide-header') && window.scrollY < HEADER_GUARD_PX) {
          document.body.classList.remove('hide-header');
        }
      }
    });
  });
  hideHeaderObserver.observe(document.body, { attributes: true });

  // Fix 3: Search bar closes when typing
  function patchSearchPopdown() {
    var searchPopdowns = document.querySelectorAll('search-popdown');
    searchPopdowns.forEach(function(popdown) {
      if (popdown._searchFocusPatched) return;
      popdown._searchFocusPatched = true;
      var wrapper = popdown.searchFormWrapper
        || popdown.querySelector('predictive-search')
        || popdown.querySelector('search-form');
      if (!wrapper) return;
      popdown.addEventListener('focusout', function() {
        requestAnimationFrame(function() {
          setTimeout(function() {
            if (!wrapper.contains(document.activeElement) && !popdown.contains(document.activeElement)) {
              if (typeof wrapper.close === 'function') wrapper.close();
            }
          }, 150);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchSearchPopdown);
  } else {
    patchSearchPopdown();
  }
  document.addEventListener('shopify:section:load', patchSearchPopdown);

})();
